module.exports = function() {
  return new Worker(__webpack_public_path__ + "d2cf7505c6b4f09c8f47.worker.js");
};